import { init as initDownloads } from './downloads'
import { init as initLPAnimation } from './lp-animation'
import { init as initLPQuizForm } from './lp-quiz'

const logErrors = function (err: unknown): void {
  console.error(err)
}

initDownloads().catch(logErrors)
initLPAnimation().catch(logErrors)
initLPQuizForm().catch(logErrors)
